'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Skeleton } from '../../skeleton';

import styles from './BarChart.Skeleton.module.scss';

export type BarChartSkeletonProps = BaseComponentProps & {
  labels: number;
};

function BarChartSkeleton({ style, className, labels }: BarChartSkeletonProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      <div className={styles['bars']}>
        <Skeleton width={20} height={120} />
        <Skeleton width={20} height={140} />
        <Skeleton width={20} height={200} />
        <Skeleton width={20} height={180} />
        <Skeleton width={20} height={160} />
        <Skeleton width={20} height={120} />
      </div>
      <div className={styles['legend']}>
        {Array.from(Array(labels)).map((_, index) => (
          <Skeleton className={styles['legend__item']} width={70} key={index} />
        ))}
      </div>
    </div>
  );
}

export { BarChartSkeleton };
